export enum MeteoConditionsID {
  TEMPERATURE = 'temperatura',
  RELATIVE_HUMIDITY = 'humedad',
  WIND_SPEED = 'viento',
  WIND_DIRECTION = 'direccionViento',
  CLOUDINESS = 'nubosidad',
  PRECIPITATION = 'precipitacion'
}
